import { render, staticRenderFns } from "./studysixth.vue?vue&type=template&id=095ea8bc&scoped=true"
import script from "./studysixth.vue?vue&type=script&lang=js"
export * from "./studysixth.vue?vue&type=script&lang=js"
import style0 from "./studysixth.vue?vue&type=style&index=0&id=095ea8bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095ea8bc",
  null
  
)

export default component.exports